import {post} from '../utils/request'

export default {
    getAll(query) {
        return post("/admin/epUser/list", query || {});
    },
    findById: function (id) {
        return post("/admin/epUser/show", {id});
    },
    findLast: function() {
        return post("/admin/epUser/last", {});
    },
    create: function (account) {
        return post("/admin/epUser/create", account);
    },
    update: function (account) {
        return post("/admin/epUser/update", account);
    },

    deleteById: function (id) {
        return post("/admin/epUser/delete", {id});
    },
}
